<h2 mat-dialog-title class="title">
  Your Career Interest Results
</h2>
<mat-dialog-content class="content">
  <div class="score-content">
    <div class="scores-div">
      <p class="sub-desc-text score-text">Your Score:</p>
    </div>

    @for (item of categoryKeys; track $index) {
      <div class="scores-div">
        <div class="category">
          <div 
            class="riasec-box" 
            [class]="`${$index <= 1 ? 'riasec-highlighted' : ''}`"
          >
            <p class="riasec-category-text">{{ item.charAt(0) | uppercase }}</p>
          </div>
          <div>
            <p class="category-heading">{{ categories[item].title }}</p>
            <p class="category-desc">{{ categories[item].description }}</p>
          </div>
        </div>
        <div class="score">
          @if (debugModeService.isDebugMode) {
            <span class="debug-raw-score">{{ getRawScore(item) }}/30</span>
          }
          <img 
            [src]="`/assets/icons/riasec/scores/${riasecPercentages[item].star}-star.svg`" 
            alt="" />
          <p class="score-result">{{ riasecPercentages[item].qualifier }}</p>
        </div>
      </div>
    }
  </div>
  <p class="description">
    This activity helped gauge your interest in different categories of work environments 
    and activities you may enjoy most. These categories make up the RIASEC model, 
    a framework used for decades in career research and job settings. 
    Studies show that finding a job aligned with your career interests can lead to 
    higher job satisfaction, better performance, and long-term success.
  </p>
  <!-- <div class="result-note" (click)="toggleFootNote()">
    <p class="result-footnote">How to interpret your results</p>
    <img 
      [src]="`/assets/icons/survey/circle-caret-${showFootnote ? 'up' : 'down'}.svg`" 
      alt="caret" 
    />
  </div>
  <p class="description" [class]="showFootnote ? 'show-note' : ''">
    This activity helped gauge your interest in different categories of work environments 
    and activities you may enjoy most. These categories make up the RIASEC model, 
    a framework used for decades in career research and job settings. 
    Studies show that finding a job aligned with your career interests can lead to 
    higher job satisfaction, better performance, and long-term success.
  </p> -->
</mat-dialog-content>
<mat-dialog-actions>
  <button
    *ngIf="showButton"
    mat-flat-button
    mat-dialog-close
    type="button"
    class="account-btn button-primary-focus"
    (click)="createAccountBtn()"
  >
  View top career matches
  </button>
  <button
    *ngIf="showCloseButton"
    mat-flat-button
    mat-dialog-close
    type="button"
    class="close-btn"
  >
  Close
  </button>
</mat-dialog-actions>
